import request from '../../../helpers/request';

const deleteHouseAttachment = async (houseId, attachId) => {
  const response = await request.delete(
    `/HousingStock/house/${houseId}/attachment`,
    {
      attachId,
    },
    'Не удалось удалить документ'
  );

  return response;
};

export default deleteHouseAttachment;
